<template>
    <ModalConfirm
        id="modal-confirm-cancel-ec-kas-kecil"
        title="Konfirmasi Batalkan EC"
        desc="Apakah Anda yakin ingin membatalkan EC kas kecil ini?"
        :isSubmitting="isSubmitting"
        alertVariant="danger"
        alertMessage="<i class='fa fa-exclamation-triangle mr-2'></i><strong>Perhatian:</strong> Kas Kecil akan dikembalikan ke status Berjalan."
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-cancel-ec",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
